import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  TimePicker,
  Tooltip,
  Typography,
} from "antd";

export function FormFiscalizacoes() {
  return (
    <>
      <Divider orientation="left" plain>
        <Typography.Title level={5}>Fiscalizações Realizadas</Typography.Title>
      </Divider>

      <Row
        gutter={[16, 16]}
        style={{ maxHeight: 600, overflow: "auto", padding: 8 }}
      >
        <Col span={24}>
          <Form.List name="fiscalizacoes">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Row key={key} gutter={16} align="middle">
                    <Col xs={24} sm={12} md={5}>
                      <Form.Item
                        {...restField}
                        label="Data"
                        name={[name, "data"]}
                      >
                        <DatePicker
                          format={"DD/MM/YYYY"}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={5}>
                      <Form.Item
                        {...restField}
                        label="Hora Inicial"
                        name={[name, "horaInicial"]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format={"HH:mm"}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={5}>
                      <Form.Item
                        {...restField}
                        label="Hora Final"
                        name={[name, "horaFinal"]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format={"HH:mm"}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={5}>
                      <Form.Item
                        {...restField}
                        label="Placa"
                        name={[name, "placa"]}
                      >
                        <Input placeholder="xxxx-xxxx" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={4}>
                      <Form.Item noStyle>
                        <Tooltip title="Remover Fiscalização" destroyOnHidden>
                          <Button
                            danger
                            size="small"
                            icon={<MinusOutlined />}
                            onClick={() => remove(name)}
                            disabled={fields.length === 1}
                          />
                        </Tooltip>
                      </Form.Item>
                    </Col>
                  </Row>
                ))}

                <Row gutter={[16, 16]} justify="center">
                  <Col>
                    <Button
                      type="dashed"
                      onClick={() => {
                        add();
                      }}
                      block
                      icon={<PlusOutlined />}
                    >
                      Adicionar Fiscalização
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Form.List>
        </Col>
      </Row>
    </>
  );
}
